import React from 'react';
import { number } from 'prop-types';

import { addDays, toJSDate } from '@ajaibid/utils';
import { Row, Col, Input, Typography } from '@ajaibid/components';

import { useStockBuySellContext } from '../../../hooks';
import { CONST_AUTO_MAX_END_DATE } from '../../../../constants';

const InputStartDate = (props) => {
  const { marginTop, marginBottom } = props;

  const { code, formState, formKey, formAction, dispatch } = useStockBuySellContext();

  return (
    <Row noGutters marginTop={marginTop} marginBottom={marginBottom}>
      <Col size={3}>
        <Typography type="body" bold margin={0}>
          Mulai
        </Typography>
      </Col>
      <Col size={9}>
        <Input.Date
          id={formKey.INPUT_START_DATE}
          name={formKey.INPUT_START_DATE}
          block
          size="sm"
          minDate={new Date()}
          maxDate={toJSDate(addDays(new Date(), CONST_AUTO_MAX_END_DATE))}
          defaultValue={null}
          value={formState[formKey.INPUT_START_DATE]}
          onChange={(e) =>
            dispatch({ type: formAction.CHANGE_AUTO_START_DATE, code, payload: e.target.value })
          }
        />
      </Col>
    </Row>
  );
};

InputStartDate.propTypes = {
  marginTop: number,
  marginBottom: number,
};

InputStartDate.defaultProps = {
  marginTop: 0,
  marginBottom: 0,
};

export default InputStartDate;
